<template>
  <VDialog
    v-if="value"
    :value="value"
    @input="$emit('input',$event)"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    :hide-overlay="$vuetify.breakpoint.smAndDown"
    persistent
    max-width="900"
  >
    <VCard class="office-interview-recording ">
      <DialogHeader
        v-if="showVideoCallCloseButton"
        :title="$t('videoCall')"
        @close="cancel"
      />
      <AppWithLoading v-slot:default="{loader}">
        <VCardText class="pa-md-5 pa-0">
          <CandidateCreateWithSearch
            :vacancy="vacancy"
            @cancel="$emit('input',false)"
            @created="loader(() => candidateReady($event))"
            @selected="loader(() => candidateReady($event))"
          />
        </VCardText>
      </AppWithLoading>
    </VCard>
  </VDialog>
</template>

<script>
import CandidateCreateWithSearch from '@/forms/CandidateCreateWithSearch';
import { candidateInterviewType } from '@/enums';
import useCandidates from '@/compositions/useCandidates';
import AppWithLoading from '@/components/AppWithLoading';
import InterviewsQuotaExceededCandidate
  from '@/components/Payment/Quota/InterviewsQuotaExceededCandidate';
import DialogHeader from '../DialogHeader.vue';

export default {
  name: 'VacancyCandidatesKanbanVideoCall',
  components: {
    InterviewsQuotaExceededCandidate,
    AppWithLoading,
    CandidateCreateWithSearch,
    DialogHeader,
  },
  props: {
    value: Boolean,
    vacancy: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { storeVideoCall, checkIfAlreadyHasOfficeInterview } = useCandidates();

    return {
      storeVideoCall,
      checkIfAlreadyHasOfficeInterview,
    };
  },
  data() {
    return {
      showVideoCallCloseButton: true,
    };
  },
  methods: {
    cancel() {
      this.$emit('input', false);
    },
    async candidateReady(candidate) {
      const hasInterview = await this.checkIfAlreadyHasOfficeInterview(
        candidate,
        candidateInterviewType.VIDEO_CALL,
      );

      if (!hasInterview) {
        await this.storeVideoCall(candidate.id);
      }

      this.cancel();
      await this.$router.push({
        name: 'candidate',
        params: { id: this.vacancy.id, candidateId: candidate.id },
        query: { lastInterviewType: candidateInterviewType.VIDEO_CALL },
      });
    },
  },
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
videoCall: Create videocall
</i18n>

<i18n locale="ru" lang="yaml">
videoCall: Создать видеозвонок
</i18n>
